import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/Projects/Varshini DP.jpg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillMediumCircle,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";


function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row className="home-about-top-row align-items-center">
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              About Me 🤔
            </h1>
            <p className="home-about-body">
              I am a data scientist and AI engineer working at the intersection
              of applied machine learning, systems, and research. I build
              end-to-end ML systems spanning data pipelines, experimentation,
              model training, deployment, and evaluation, with a strong focus on
              reliability and reproducibility.
              <br />
              <br />
              I’m currently seeking <strong>AI research/engineering</strong>,{" "}
              <strong>forward-deployed engineer (FDE)</strong>, or{" "}
              <strong>developer relations</strong> roles at AI-first companies.
              <br />
              <br />
              As a researcher, I focus on understanding and improving the
              real-world behavior of AI systems, particularly large language
              models. My interests include model reliability, evaluation-first
              development, alignment failures, and how AI systems influence trust
              in information and institutions.
              <br />
              <br />
              As a founder, I am building Career Mojo, a credibility-first career
              guidance and early hiring platform. I am currently onboarding my
              first users and collaborating with early-stage startups and
              recruiters to improve how early career talent is discovered and
              evaluated.
              <br />
              <br />
              As a problem solver, I am motivated by high-impact applications of
              AI that serve public good. I actively follow SOTA work done in building trustworthy
              information systems, advancing personalized education using AI. Use of
              AI to improve urban infrastructure, and disaster management intrigues me.
              <br />
              <br />
              I bring prior industry experience in E-Commerce (Swift) and Space Science Campaigns (SETI), strong
              cross-functional communication skills, and a product-driven mindset grounded in real deployment constraints.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>Ping Me</h1>
            <p>
             Let's Connect </p>
            
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/varshini2305"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://x.com/vbgrandmaster"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/varshini-balaji-132707154/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://medium.com/@varshinibalaji2305_28989"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillMediumCircle />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
